(() => {
  const money = c => '$' + (c / 100).toFixed(2);

  const init = (root = document) => {
    root.querySelectorAll('[data-cs-product]').forEach(section => {
      if (section.dataset.csBound) return;
      section.dataset.csBound = '1';

      const code = section.dataset.autoCode;
      if (code) {
        let done = false;
        try { done = sessionStorage.getItem('cs-code') === code; } catch (e) {}
        if (!done) fetch('/discount/' + encodeURIComponent(code), {credentials: 'same-origin'}).then(() => { try { sessionStorage.setItem('cs-code', code); } catch (e) {} }).catch(() => {});
      }

      const slider = section.querySelector('[data-cs-slider]');
      const thumbs = [...section.querySelectorAll('[data-cs-go]')];
      const go = i => slider && slider.scrollTo({left: i * slider.clientWidth, behavior: 'smooth'});
      thumbs.forEach(t => t.addEventListener('click', () => go(+t.dataset.csGo)));
      if (slider) {
        let raf = 0;
        slider.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(slider.scrollLeft / slider.clientWidth);
            thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
            const on = thumbs[i];
            if (on) on.parentElement.scrollTo({left: on.offsetLeft - on.parentElement.clientWidth / 2 + on.clientWidth / 2, behavior: 'smooth'});
          });
        }, {passive: true});
      }

      const picker = section.querySelector('[data-cs-picker]');
      const form = section.querySelector('form[data-ajax-cart]');
      if (picker && form) {
        const variants = JSON.parse(picker.querySelector('[data-cs-variants]').textContent);
        const read = () => [1, 2, 3].map(i => {
          const sel = picker.querySelector(`select[data-cs-index="${i}"]`);
          if (sel) return sel.value;
          const r = picker.querySelector(`input[data-cs-index="${i}"]:checked`);
          return r ? r.value : null;
        });
        const find = o => variants.find(v => o.every((x, i) => x === null || v[`option${i + 1}`] === x));
        const update = (fromColour) => {
          const o = read();
          picker.querySelectorAll('[data-cs-pack]').forEach(card => {
            const input = card.querySelector('input');
            const idx = +input.dataset.csIndex - 1;
            const oo = o.slice(); oo[idx] = input.value;
            const pv = find(oo);
            card.classList.toggle('is-on', input.checked);
            if (!pv) return;
            card.querySelector('[data-cs-pack-price]').textContent = money(pv.price);
            const save = card.querySelector('[data-cs-pack-save]');
            if (pv.compare_at_price > pv.price) { save.hidden = false; save.textContent = 'Save ' + Math.round((1 - pv.price / pv.compare_at_price) * 100) + '%'; }
            else save.hidden = true;
          });
          o.forEach((val, i) => { const c = picker.querySelector(`[data-cs-current="${i + 1}"]`); if (c && val) c.textContent = val; });
          const v = find(o);
          if (!v) return;
          form.querySelector('[name="id"]').value = v.id;
          section.querySelectorAll('[data-price]').forEach(el => el.textContent = money(v.price));
          section.querySelectorAll('[data-compare]').forEach(el => { const s = v.compare_at_price > v.price; el.hidden = !s; el.textContent = s ? money(v.compare_at_price) : ''; });
          section.querySelectorAll('form[data-ajax-cart] [type="submit"], [data-cs-sticky] button').forEach(b => { b.disabled = !v.available; b.textContent = v.available ? b.dataset.add : b.dataset.soldOut; });
          const url = new URL(location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
          if (fromColour && slider && v.featured_media) {
            const slides = [...slider.children];
            const i = slides.findIndex(s => s.dataset.mediaId == v.featured_media.id);
            if (i > -1) go(i);
          }
        };
        picker.addEventListener('change', e => {
          const label = e.target.closest('.cs-opt')?.querySelector('.cs-label')?.textContent.toLowerCase() || '';
          update(label.includes('colo'));
        });
        update(false);
      }

      const sticky = section.querySelector('[data-cs-sticky]');
      const buy = section.querySelector('.cs-buy');
      if (sticky && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(([e]) => { sticky.hidden = e.isIntersecting; }).observe(buy);
      }
    });
  };

  document.addEventListener('shopify:section:load', e => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
